import React, { useEffect, useState } from 'react';
import { useBenchmarkClient } from '@/Hooks/ClientHooks';
import { useCandidatesResultsContext } from '../../../../Contexts/CandidateResultsContext';
import { AssessmentMeanBenchmark, DefaultAssessmentMeanBenchmark } from '@/Models/AssessmentMeanBenchmark';
import { TestTypes } from '@/Models/Configuration';
import BenchmarkHeader from './Components/BenchmarkHeader';
import BenchmarkTabs from './Components/BenchmarkTabs';
import { TestScore } from '@/Models/TestScore';

export interface BenchmarkPanelProps {
    candidateFirstName: string;
    candidateScore: TestScore;
    testType: TestTypes;
}

function BenchmarkPanel({ candidateFirstName, candidateScore, testType }: BenchmarkPanelProps): React.JSX.Element {
    const client = useBenchmarkClient();
    const { assessmentId } = useCandidatesResultsContext();
    const [benchmark, setBenchmark] = useState<AssessmentMeanBenchmark>(DefaultAssessmentMeanBenchmark);

    useEffect(() => {
        const doGetBenchmark = async () => {
            const response = await client.getMeanBenchMarkAsync(assessmentId);
            setBenchmark(response);
        };
        doGetBenchmark();
    }, []);

    return (
        <div className="border-border bg-card rounded-xl border p-5">
            <BenchmarkHeader />
            <BenchmarkTabs
                candidateFirstName={candidateFirstName}
                candidateScore={candidateScore}
                testType={testType}
                benchmark={benchmark}
            />
        </div>
    );
}

export default BenchmarkPanel;
